import { $qs, $qsa } from '../utils/querySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollToPlugin);



function horizontalScrollBanner() {
    const menu = $qs('[data-target="menu"]');
    const container = $qs('[data-target="scroll-container"]');
    const sections = $qsa('[data-target="scroll-section"]');
    const background = $qs('[data-target="scroll-background"]');
    const video = $qs('[data-target="scroll-video"]');
    const button = $qs('.js-banner-button');
    const videoContainer = video.closest('[data-target="scroll-section"]');
    const parallaxElements = $qsa('[data-aos="parallax"]');
    const cardsSection = $qs('[data-name="cards"]');
    var bannerSplit = new SplitText("[data-name='banner'] .banner-split-text", { type: "chars,lines" });
    var split = new SplitText("[data-name='banner'] .split-text", { type: "chars,lines" });
    var bannerSplitLines = document.querySelectorAll("[data-name='banner'] .banner-split-text > div");
    var splitLines = document.querySelectorAll("[data-name='banner'] .split-text > div");
    var cutout1 = document.querySelector('.js-cutout-1');
    var cutouts = document.querySelectorAll('.js-cutout');
    [...splitLines].forEach(line => {
        // var wrapper = document.createElement('div');        
        // wrapper.classList.add('overflow-hidden');
        // line.parentNode.insertBefore(wrapper, line);
        // wrapper.appendChild(line);
        line.style.overflow = "hidden";
    });
    [...bannerSplitLines].forEach(bannerLine => {                        
        // var wrapper = document.createElement('div');        
        // wrapper.classList.add('overflow-hidden');
        // bannerLine.parentNode.insertBefore(wrapper, bannerLine);
        // wrapper.appendChild(bannerLine);
        // bannerLine.style.marginBottom = "-16px"        ;
        bannerLine.style.overflow = "hidden";
    });
    const getMaxWidth = () => [...sections].reduce((val, section) => val + section.offsetWidth, 0);
    const maxWidth = getMaxWidth();
    
    const scrollSpeed = 1;

    // console.log(maxWidth);
    gsap.to("[data-name='banner'] .banner-split-text", {
        opacity: 1,
    });
    
    [...bannerSplitLines].forEach(bannerLine => {  
        setTimeout(() => {
            var bannerSplitLetters = bannerLine.querySelectorAll("div");                   
            // console.log(bannerSplitLetters) 
            gsap.fromTo(bannerSplitLetters, { 
                opacity: 0, 
                y: '155px' 
            }, { 
                opacity: 1, 
                y: 0, 
                duration: 1, 
                stagger: 0.045, 
                ease: "power4.out",            
            });
        }, 500);
        

    });
    gsap.fromTo(button, {
        opacity: 0,
        y: "30px"
    }, {
        opacity: 1,
        y: 0
    })
    gsap.fromTo(cutout1, {
        opacity: 0,
        autoAlpha: 0,
        x: "100px"
    }, {
        opacity: 1,
        autoAlpha: 1,
        x: 0,
        duration: 3.5,
        ease: "power4.out"
    })
    const timeline = gsap.timeline();

    timeline        
        .to(sections, {
            x: () => window.innerWidth - maxWidth,
            ease: 'none',
        });

    ScrollTrigger.create({
        animation: timeline,
        trigger: container,
        pin: true,
        pinSpacing: true,
        scrub: 1.6,
        //   snap: {snapTo: directionalSnap(timeline), duration: 0.5},
        end: () => `+=${maxWidth / scrollSpeed}`,
        invalidateOnRefresh: true
    });

    document.querySelector("[data-banner-scroll]").addEventListener("click", () => {
        // gsap.to(window, {scrollTo: getScrollPosition(redTween)});        
        gsap.to(window, {scrollTo: (window.innerWidth)});        
    });

      
    document.querySelectorAll(".split-text").forEach(splitText => {
        const splitLines2 = splitText.querySelectorAll(".split-text > div");        
        // console.log(splitLines2);
        // gsap.fromTo(splitLines2, {
        //     opacity: 0,
        //     y: '130px',
        // }, {
        //     opacity: 1,
        //     scrollTrigger: {
        //         containerAnimation: timeline,
        //         trigger: splitText,
        //         start: `left+=${splitText.offsetWidth / 2}px right`,
        //         // markers: true,
        //     },
        //     duration: 1,
        //     ease: "power4.out",
        //     y:0,

        // });
        [...splitLines2].forEach(line2 => {    
        // console.log(line2);                                      
            var splitLetters = line2.querySelectorAll("div");        
            gsap.fromTo(splitLetters, { 
                opacity: 0, 
                x: '55px',
                y: '55px' 
            }, { 
                opacity: 1, 
                x: 0,
                y: 0, 
                duration: 0.7, 
                stagger: 0.025,
                ease: "power3.out",
                scrollTrigger: {
                    containerAnimation: timeline,
                    trigger: splitText,
                    start: `left+=${splitText.offsetWidth / 3}px right`,
                    // markers: true,
                }
            })
        });
        if(window.matchMedia('(min-width: 1025px) and (min-height:550px) and (max-width:1300px) and (max-height:750px)').matches) {
            var end = `right-=${splitText.offsetWidth}px left`
        } else {
            var end = `right-=${splitText.offsetWidth / 3}px left`
        }
        gsap.to(splitText, {
            // x: `-${window.innerWidth / 2.5}px`,
            x: "170px",
            ease: 'none',
            scrollTrigger: {
                containerAnimation: timeline,
                trigger: splitText,
                scrub: 1.3,
                start: `left+=${splitText.offsetWidth / 3}px right`,
                end: end,                                
                // markers: true,
                onEnterBack: function() {
                    gsap.to(splitText, { opacity: 1, xPercent: 0, duration: 0.3, ease: 'power4.out'})
                },
            },
            onComplete: function() {
                gsap.to(splitText, { opacity: 0, xPercent: -100, duration: 1, ease: 'power4.out'})                

                
            },
            
            
        })
    });
    
    [...cutouts].forEach(cutout => {
        gsap.fromTo(cutout, {
            opacity: 0,
            autoAlpha: 0,
            x: `${cutout.offsetWidth / 1.5}px`
        }, {
            opacity: 1,
            autoAlpha: 1,
            x: 0,
            duration: 2,
            ease: "power4.out",
            scrollTrigger: {
                containerAnimation: timeline,
                trigger: cutout,
                // scrub: 1.3,
                start: `left right`,
                // end: `right-=${cutout.offsetWidth / 2}px left`,         
                // markers: true,       
                // onEnterBack: function() {
                //     gsap.to(cutout, { opacity: 1, xPercent: 0, duration: 0.9, ease: 'power4.in'})
                // }
                
            },
            // onComplete: function() {
            //     gsap.to(cutout, { opacity: 0, xPercent: -100, duration: 0.4, ease: 'power4.in'})                
            // },        
            // onComplete: function() {
            //     gsap.to(cutout, {
            //         x: `-${window.innerWidth / 4}px`,
            //         ease: 'none',
            //         scrollTrigger: {
            //             containerAnimation: timeline,
            //             trigger: cutout,
            //             scrub: 1.1,
            //             // start: `left+=${cutout.offsetWidth / 3}px right`,
            //             // end: `right left`,                
            //         }
            //     })
            // }
        })

    });
    // animate elements to have parallax on horizontal scroll
    [...parallaxElements].forEach(parallaxElement => {
        const imageContainer = $qs('[data-aos-target="image-container"]', parallaxElement);
        const image = $qs('[data-aos-target="image"]', parallaxElement);

        gsap.to(image, {
            x: () => `-${parallaxElement.offsetWidth}px`,
            duration: 0.5,
            ease: 'none',
            scrollTrigger: {
                trigger: parallaxElement,
                containerAnimation: timeline,
                scrub: 0.5,
                start: `left+=${parallaxElement.offsetWidth / 3}px right`,
                end: `left-=${parallaxElement.offsetWidth/2} left`,                                
                markers: false,
                onEnterBack: function() {
                    gsap.to(image, { opacity: 1, xPercent: 0, duration: 0.3, ease: 'power4.out'})
                }
            },
            onStart: function () {
                imageContainer.dataset.aosState = 'active';
            },
            onComplete: function() {
                gsap.to(image, { opacity: 0, xPercent: -100, duration: 1, ease: 'power4.out'})                
            },
                    

        });
        

        
    });

    
    // pin background during horizontal scroll
    ScrollTrigger.create({
        trigger: container,
        start: 'top top',
        end: () => `+=${(maxWidth / scrollSpeed) + window.innerHeight}`,
        pin: background,
        // markers: true,
    });
    
    // setTimeout(() => {
    gsap.to(video, {
        scale: 1,
        duration: 1,
        ease: 'none',
        scrollTrigger: {
            trigger: videoContainer,
            // containerAnimation: timeline,
            scrub: 1.5,
            pin: container,
            pinSpacing: true,
            start: `+=${maxWidth / scrollSpeed}`,
            // start: 'left left',
            // end: `+=${(maxWidth / scrollSpeed) + window.innerHeight}`,
            end: `+=${window.innerHeight * 2}`, 
            // markers: true,
            }
        });
    // }, 2000);

    // pin menu during horizontal scroll
    ScrollTrigger.create({
        trigger: container,
        start: 'top top',
        end: () => `+=${(maxWidth / scrollSpeed) + (window.innerHeight * 2)}`,
        pin: menu,
        // markers: true,
    });


    // pin video container to simulate cards section covering it
    ScrollTrigger.create({
        trigger: cardsSection,
        start: 'top bottom',
        end: 'top top',
        pin: videoContainer,
        pinReparent: true,
        // markers: true,
    });

    ScrollTrigger.sort();


}

function cardStickyCalc() {
    var cards = document.querySelectorAll('[data-target="card"]');
    var windowHeight = window.innerHeight;
    var cardHeights = [];
    [...cards].forEach((card) => {
        cardHeights.push(card.offsetHeight) ;
    });

    // console.log(cardHeights);
    var tallestCardHeight = Math.max(...cardHeights);
    console.log(tallestCardHeight);
    [...cards].forEach((card) => {
        // let cardHeight = card.offsetHeight;
        card.style.height = `${tallestCardHeight}px`;
        if((tallestCardHeight + 100) > windowHeight) {
            card.style.top = (windowHeight - tallestCardHeight) - 30 + "px";
        } else {
            card.style.top = "100px";
        }
    });

    [...cards].forEach((card) => {
        gsap.from(card, {
            y: "200px",
            ease: "power4.out",
            scrollTrigger: {
                trigger: card,
                start: 'top bottom'
            }
        })
    })
    
}

function cardSliders() {

    var homepageStatSliders = document.querySelectorAll('[data-element="stat-slider"]');
    homepageStatSliders.forEach((statSlider) => {
    	
    	var statSwiper = new Swiper(statSlider, {       
    		slidesPerView: 1,
    		modules: [ Autoplay, Pagination ],                            
    		loop: true,		
    		autoplay: {
    			delay: 5000,
    			disableOnInteraction: false,
    		  },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }

    	});
    });
    var homepageBlockquoteSliders = document.querySelectorAll('[data-element="homepage-quote-slider"]');
    homepageBlockquoteSliders.forEach((quoteSlider) => {
    	
    	var quoteSwiper = new Swiper(quoteSlider, {       
    		slidesPerView: 1,
    		modules: [ Autoplay, Pagination ],                            
    		loop: true,		
    		autoplay: {
    			delay: 5000,
    			disableOnInteraction: false,
    		  },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }

    	});
    });
    var homepagePostsSliders = document.querySelectorAll('[data-element="posts-slider"]');
    homepagePostsSliders.forEach((postSlider) => {
    	
    	var postSwiper = new Swiper(postSlider, {       
    		slidesPerView: 1,
    		modules: [ Autoplay, Pagination ],                            
    		loop: true,		
    		autoplay: {
    			delay: 5000,
    			disableOnInteraction: false,
    		  },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }

    	});
    });
}

function mobileCardSlider() {
    var homepageCards = document.querySelectorAll('.mobile-card-slider');
    homepageCards.forEach((cards) => {        
    	cards.classList.add('swiper');
        cards.querySelector('.wrapper-here').classList.add('swiper-wrapper');

    	var mobileCardSwiper = new Swiper(cards, {       
    		slidesPerView: 1,
    		modules: [ Autoplay, Pagination ], 
            spaceBetween: 40,    
            autoHeight: true,                       
    		loop: true,		
    		autoplay: {
    			delay: 7000,
    			disableOnInteraction: false,
    		  },
            pagination: {
                el: '.swiper-card-pagination ',
                clickable: true
            }

    	});
    });
}

function newsImageMove() {
    document.addEventListener("mousemove", mouseMoveFunc);

    let images = gsap.utils.toArray("[data-target='news-image']");

    function mouseMoveFunc(e) {

        images.forEach((image, index) => {
        const depth = 10;
        const moveX = (e.pageX - window.innerWidth / 2) / depth;
        const moveY = (e.pageY + 300) / e.pageY ;

        index ++

        gsap.to(image, {
          x: moveX ,
          y: '-50%',
          rotate: 0.05*moveX
        });
      });
    }
}


function Home() {
    if (!$qs('.page-template-home')) return;
    
    window.addEventListener('load', () => {         
        if(window.matchMedia("(min-width:1200px)").matches) {
            horizontalScrollBanner();
        }
        if(window.matchMedia("(min-width:828px)").matches) {
            newsImageMove()
        }      
        if(window.matchMedia("(min-width:700px)").matches ) {            
            cardStickyCalc();
            cardSliders();         

        } else {
            mobileCardSlider();
        }
    });
}

export default Home;